module.exports = __webpack_public_path__ + "static/media/comment.809879ce.svg";